import { html } from "lit"
import { sanitizeHeaderHref } from "@ligonier/shared"

import type { TemplateResult } from "lit"
import { formatDate } from "@ligonier/shared"

export function renderFooterGroups(sections: Array<any>): TemplateResult {
  return html`
    <div class="footer-groups">
      <div class="container container-sm footer-groups-container">
        ${sections.map(
          (section) => html`
            <section class="footer-group">
              <h3 class="footer-group-title">${section.name}</h3>
              <div class="footer-group-links">
                ${!section.name?.toLowerCase()?.includes('events')
                  ? section.linksCollection?.items.map(
                      (link: { url: unknown; name: unknown }) => html`
                        <a href="${sanitizeHeaderHref(link.url)}" class="footer-group-link"
                          >${link.name}</a
                        >
                      `
                    )
                  : section.linksCollection?.items.map(
                      (link: {
                        startDate: string
                        url: unknown
                        title: unknown
                      }) => html`
                        <div style="display: flex; flex-direction: column;">
                          <span class="footer-group-link-separator"
                            >${formatDate(link.startDate)}</span
                          >
                          <a href="${sanitizeHeaderHref(link.url)}" class="footer-group-link"
                            >${link.title}</a
                          >
                        </div>
                      `
                    )}
                ${section.name?.toLowerCase()?.includes('events')
                  ? html`
                      <a
                        href="https://www.ligonier.org/events"
                        class="footer-group-link-all"
                        >View All Events</a
                      >
                    `
                  : null}
              </div>
            </section>
          `
        )}
      </div>
    </div>
  `;
}
